import MoreVertIcon from '@mui/icons-material/MoreVert';
import React, {useState} from 'react';
import {IconButton, Menu, Tooltip} from '@mui/material';
import {any, func, object, string} from 'prop-types';

const ActionsMenuButton = ({
  tooltipTitle,
  children,
  onClick,
  onClose,
  target,
  MenuProps = {},
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    if (onClick) {
      onClick(event);
    }
  };

  const handleClose = event => {
    setAnchorEl(null);
    if (onClose) {
      onClose(event);
    }
  };

  const menuItems = React.Children.toArray(children)
    .filter(Boolean)
    .map(child =>
      React.cloneElement(child, {
        onClick: event => {
          handleClose(event);
          if (child.props.onClick) {
            child.props.onClick();
          }
        },
      })
    );

  return (
    <>
      <Tooltip title={tooltipTitle || ''} placement="bottom">
        <IconButton
          aria-label={`${target} more actions menu`}
          size="small"
          onClick={handleClick}
          {...props}
        >
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        {...MenuProps}
      >
        {menuItems}
      </Menu>
    </>
  );
};

ActionsMenuButton.propTypes = {
  children: any,
  tooltipTitle: string,
  onClick: func,
  onClose: func,
  target: string,
  MenuProps: object,
};

export default ActionsMenuButton;
